var __rspack_ns_object = {"rE":"8.0.2"}